import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CargoAllocationService from './../../services/cargoallocation.service';

export default {
  name: 'deliveryuserlogout',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      listUserData: [],
      currentHub:[],
      userid:'',
      isLoading: false
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub.push(userdetail.hubID[0]);
    this.getSRUserList();
  },
  methods: {
    customLabel ({ FirstName, LastName, userid, MobileNumber }) {
      return `${FirstName} ${LastName}(${userid}) - ${MobileNumber}`
    },
    async getSRUserList() {
      try {
        let InputPayload = {
            hubid: this.currentHub
        };
        this.isLoading = true;
        let response = await CargoAllocationService.getSRUserList(InputPayload);
        this.isLoading = false;
        if(response.data.code == 200){
          this.listUserData = response.data.data;
        }else {
          this.$alert("Unable to fetch records.","User","error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async forceLogout(event){
      try {
        let InputPayload = {
          userid: this.userid.userid,
          modifiedby: this.localuserid
        };
        this.isLoading = true;
        let response = await CargoAllocationService.forceLogout(InputPayload);
        this.isLoading = false;
        if (response.data.code == 200) {
            this.$alert(response.data.message,"","success");
        } else {
            this.$alert(response.data.error,"","error");
        }
        this.resetForm();
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    resetForm() {
      this.userid = '';
      this.$validator.reset();
      this.errors.clear();
      this.getSRUserList();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.forceLogout(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargoallocation/views/deliveryuserlogout/deliveryuserlogout.component.js